/* eslint-disable jsx-a11y/control-has-associated-label */
import CloseIcon from '@mui/icons-material/Close';
import Modal from 'react-modal';
import { IBankAccountViewModel } from 'viewModels';
import { ReactComponent as DeleteIcon } from '../../../assets/icons/IconDelete.svg';
import { BasicButton } from '../../Buttons/BasicButton';
import { ContentModal, Header } from './styles';

interface ModalDeleteBankAccountProps {
  isOpen: boolean;
  currentBankAccount: IBankAccountViewModel;
  onRequestClose: () => void;
  onRequestRemoveBankAccount: () => void;
}

export function ModalDeleteBankAccount({
  onRequestRemoveBankAccount,
  currentBankAccount,
  isOpen,
  onRequestClose,
}: ModalDeleteBankAccountProps) {
  const handleDeleteBankAccount = () => {
    onRequestRemoveBankAccount();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName="react-modal-overlay"
      className="react-delete-modal-content">
      <Header>
        <div className="subHeader">
          <DeleteIcon />
          <h1>Exclusão</h1>
        </div>
        <div className="close-div">
          <button type="button" onClick={onRequestClose}>
            <CloseIcon fontSize="small" />
          </button>
        </div>
      </Header>
      <ContentModal>
        <h2 className="confirmationText">Deseja realmente excluir a conta bancária?</h2>
        Agência: <p>{currentBankAccount.agency}</p>
        Conta: <p>{currentBankAccount.accountNumber}</p>
        <div className="buttonModal">
          <BasicButton variant="outlined" size="medium" onClick={onRequestClose}>
            Cancelar
          </BasicButton>
          <BasicButton variant="outlined" size="medium" onClick={handleDeleteBankAccount}>
            Excluir
          </BasicButton>
        </div>
      </ContentModal>
    </Modal>
  );
}
